var $ = jQuery;

var handlerNavigation = {
  $mobileMenuMain: $('.mobile-menu-main'),
  $mobileSubmenus: $('.mobile-submenu'),
  $trigger: $('.mobile-menu-trigger'),
  $sections: $('section'),
  adjustFirstSectionPadding: function() {
    var $firstSection = $main.children('section').eq(0);
    var $headerBuffer = $firstSection.find('> .header-buffer');
    if (!$firstSection.is('body.home .hero') && $headerBuffer.length == 0) {
      $headerBuffer = $('<div class="header-buffer"></div>').prependTo($firstSection.eq(0));
    }
  },
  changeHeaderColor: function() {
    var currentSection = null;
    var scrollTop = $window.scrollTop();
    var headerHeight = $header.outerHeight();
    $(this.$sections.get().reverse()).each(function() {
      if ($(this).offset().top - headerHeight - 1 <= scrollTop) {
        currentSection = this;
        return false;
      }
    });
    var currentSectionClasses = currentSection.className.split(/\s+/);
    var bgColor = 'bg-white';
    // special handling for specific page
    if ($('body.home').length > 0 && $(currentSection).is('#hero, #intro')) {
      bgColor = 'bg-transparent bg-home-transparent';
    } else {
      for (var i=0; i<currentSectionClasses.length; i++) {
        if (currentSectionClasses[i].startsWith('bg-') && !currentSectionClasses[i].startsWith('bg-pattern') && currentSectionClasses[i] !== 'bg-none') {
          bgColor = currentSectionClasses[i];
          break;
        }
      }  
    }
    var currentHeaderClasses = $header.get(0).className.split(/\s+/);
    var newHeaderClasses = [];
    for (var i=0; i<currentHeaderClasses.length; i++) {
      if (!currentHeaderClasses[i].startsWith('bg-')) {
        newHeaderClasses.push(currentHeaderClasses[i]);
      }
    }
    newHeaderClasses.push(bgColor);
    $header.attr("class", newHeaderClasses.join(' '));
    if (this.$sections.eq(0).is('.hero')) {
      if (scrollTop <= 0) {
        var revealDisplayed = false;
        $('.reveal').each(function() {
          if ($(this).is(':visible')) {
            revealDisplayed = true;
            return false;
          }
        });
        if (!revealDisplayed) {
          $header.addClass('transparent');
        }
      } else {
        $header.removeClass('transparent');
      }
    }
    if (scrollTop <= 0) {
      $body.addClass('scroll-top');
    } else {
      $body.removeClass('scroll-top');
    }
  },
  scrollTimeout: null,
  initHeaderColorChange: function() {
    var self = this;
    $window.on("scroll", function() {
      clearTimeout(self.scrollTimeout);
      self.scrollTimeout = setTimeout(function() {
        self.changeHeaderColor();
      }, 10);
    });
    this.changeHeaderColor();
  },
  initMobile: function() {
    var self = this;
    $('.mobile-menu-trigger').on("click", function() {
      var isMenuActive = self.$trigger.hasClass('active');
      var isSubmenuActive = self.$trigger.hasClass('submenu-active');
      if (!isMenuActive) {
        self.$trigger.addClass('active');
        self.$mobileMenuMain.addClass('active');
        $('main, header, footer').addClass('menu-active');
      } else {
        if (isSubmenuActive) {
          self.$mobileSubmenus.removeClass('active');
          self.$mobileMenuMain.removeClass('submenu-active');
          self.$trigger.removeClass('submenu-active');  
        } else {
          self.$trigger.removeClass('active');
          self.$mobileMenuMain.removeClass('active');
          $('main, header, footer').removeClass('menu-active');  
        }
      }
    });
    $('.menu-item.has-submenu a').on("click", function() {
      var $menuItem = $(this);
      var $targetSubmenuPanel = $('#mobile-submenu-'+$menuItem.data('submenu-id'));
      if (!$targetSubmenuPanel.hasClass('active')) {
        var $activeSubmenu = $('.mobile-submenu').filter('.active');
        $targetSubmenuPanel.addClass('active');
        self.$mobileMenuMain.addClass('submenu-active');
        self.$trigger.addClass('submenu-active');
        setTimeout(function() {
          $activeSubmenu.removeClass('active');
        }, 250);
        if (Foundation.MediaQuery.is('large')) {
          $('main, header, footer').addClass('menu-active');
        }
      } else {
        $targetSubmenuPanel.removeClass('active');
        if (Foundation.MediaQuery.is('large')) {
          $('main, header, footer').removeClass('menu-active');
        }
      }
    });
  },
  resetSelectOptionsHeight: function() {
    $('.select-selected').each(function() {
      var $current = $(this);
      var $selectContainer = $current.parents('.select-container');
      var $options = $selectContainer.find('.select-option');
      var totalOptionsHeight = $current.parent().outerHeight() * $options.length;
      $selectContainer.css('--options-container-height', totalOptionsHeight+'px');          
    });
  },
  selectNavOption: function($target, scroll=false) {
    var $current = $target;
    var targetType = $current.data('target-type');
    var $selectContainer = $current.parents('.select-container');
    $selectContainer.removeClass('opened');
    $selectContainer.find('.select-option').removeClass('selected');
    $current.addClass('selected');
    $selectContainer.find('.select-selected').html($current.html());
    if (targetType == 'carousel') {
      var target = $current.data('target').split(' ');
      var $targetElement = $(target[0]);
      if ($targetElement.length > 0) {
        $targetElement.flickity('select', parseInt(target[1]));
        if (scroll) {
          this.scrollIntoView($targetElement);
        }
      }
    }
  },
  initNavSelects: function() {
    var self = this;
    $('.select-selected').on("click", function() {
      var $selectContainer = $(this).parents('.select-container');
      if ($selectContainer.is('.opened')) {
        $selectContainer.removeClass('opened');
      } else {
        $selectContainer.addClass('opened');
      }
    });
    $('.select-option').on("click", function() {
      self.selectNavOption($(this), true);
    });
    $window.on('resize', function() {
      self.resetSelectOptionsHeight();
    });
    this.resetSelectOptionsHeight();
  },
  scrollIntoView: function($target, withHeader=true) {
    var additionalOffset = parseInt($body.css('--header-height'));
    if (!withHeader) {
      additionalOffset = 0;
    }
    $('html, body').animate({
      scrollTop: $target.offset().top - additionalOffset
    }, 250);
  },
  resetStickyParent: function() {
    $('[data-sticky-parent]').each(function() {
      var $current = $(this);
      var $parent = $($current.data('sticky-parent'));
      $current.css('--sticky-width', $current.outerWidth()+'px');
      $current.css('--parent-distance', ($current.offset().top - $parent.offset().top)+'px');
    });
  },
  initStickyParent: function() {
    var $stickies = $('[data-sticky-parent]');
    if ($stickies.length > 0) {
      this.resetStickyParent();
      $window.on("scroll", function() {
        var scrollTop = $window.scrollTop();
        var headerHeight = $header.outerHeight();
        $stickies.each(function() {
          var $current = $(this);
          var doSticky = true;
          if ($current.is('[data-sticky-on]')) {
            if (!Foundation.MediaQuery.is($current.data('sticky-on'))) {
              doSticky = false;
            }
          }
          if (doSticky) {
            var $parent = $($current.data('sticky-parent'));
            var parentDistance = parseInt($current.css('--parent-distance'));
            var currentHeight = $current.outerHeight();
            if ($current.siblings('.sticky-spacer').length == 0) {
              $('<div class="sticky-spacer" style="height:'+currentHeight+'px">').insertAfter($current).hide();
            }
            if ($parent.length > 0) {
              if ($parent.offset().top + parentDistance - headerHeight < scrollTop) {
                $current.addClass('stuck');
                $current.siblings('.sticky-spacer').show();
                var parentBottom = $parent.get(0).getBoundingClientRect().bottom;
                var parentBottomDistance = $window.height() - $parent.get(0).getBoundingClientRect().bottom - headerHeight;
                if (parentBottom <= currentHeight + headerHeight) {
                  $current.css('--stuck-bottom',(parentBottomDistance + headerHeight + 2)+'px');
                  $current.addClass('at-bottom');
                } else {
                  $current.removeClass('at-bottom');
                }
              } else {
                $current.removeClass('stuck');
                $current.siblings('.sticky-spacer').hide();
              }
            }
          }
        });  
      });
    }
  },
  initNextArrow: function() {
    var self = this;
    $('[data-scroll-to-next]').on("click", function() {
      self.scrollIntoView($(this).parents('section').next('section'), false);
    });
  },
  init: function() {
    this.initMobile();
    this.initNavSelects();
    this.initStickyParent();
    // this.initNextArrow();
    this.initHeaderColorChange();
  }
}